import type { FakeInteractiveProps } from './FakeInteractive.types';

export const fakeInteractiveDefaults: FakeInteractiveProps = {
  text: '',
  isDisabled: false,
  isVisible: true,
  isDecorative: false,
};
